import React from 'react';
import {
    Backdrop,
    Box,
    Chip,
    CircularProgress,
    Slide
} from '@mui/material';

export const GetReadOnlyInputProps = (params) => ({
    ...params,
    inputProps: {
        ...params.inputProps,
        readOnly: true,


    },
});

export const sharedSnackbarAlertSx = {
    width: "100%",
    fontSize: "13px",
    py: 0.4,
    px: 1.2,
    minHeight: 28,
    alignItems: "center",
    "& .MuiAlert-icon": {
        fontSize: 18,
        mr: 0.6
    },
    "& .MuiAlert-message": {
        padding: 0,
    },
    "& .MuiAlert-action": {
        padding: 0,
        alignItems: "center",
    }
};

export function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
}

export const calculateTotalPages = (apiDataList, defaultPageSize = 40) => {
    if (!apiDataList || apiDataList.length === 0) {
        return 1;
    }
    const totalRecords = apiDataList[0]?.TotalRecords || 0;
    const pageSize = apiDataList[0]?.MaxRows || defaultPageSize;
    return Math.ceil(totalRecords / pageSize) || 1;
};

export const hasDuplicateDepartmentJobTitle = (entries) => {
    const uniqueKeys = new Set();
    for (const entry of entries) {
        if (entry.department) {
            const key = `${entry.department}|${entry.jobTitle || ''}`;
            if (uniqueKeys.has(key)) {
                return true;
            }
            uniqueKeys.add(key);
        }
    }
    return false;
};

export const hasInconsistentDepartmentJobTitle = (entries) => {
    const deptGroups = {};
    entries.forEach(entry => {
        if (entry.department) {
            if (!deptGroups[entry.department]) deptGroups[entry.department] = [];
            deptGroups[entry.department].push(!!entry.jobTitle);
        }
    });

    for (const deptId in deptGroups) {
        const flags = deptGroups[deptId];
        const hasJobTitle = flags.some(f => f);
        const allHaveJobTitle = flags.every(f => f);
        if (hasJobTitle && !allHaveJobTitle) {
            return true;
        }
    }
    return false;
};
export const Status = ({ status }) => (
    <Chip
        sx={{
            borderRadius: 0.5,
            backgroundColor: status === "active" ? "#cbe8c7" : "#fae0e3",
            fontSize: "0.56rem",
            fontWeight: 700,
            color: status === "active" ? "#0e7634" : "#e65b6c",
            width: "100px",
            textTransform: "capitalize",
            "& .MuiChip-label": {
                padding: "0px 12px", // your required padding
            }
        }}
        label={status}
        size='small'

    />
);


export function SectionBox({ height, title, children, bgcolor = "white", fontWeight = 600, minWidth = "0px" }) {
    return (
        <Box
            height={height}
            sx={{
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: 1,
                padding: 2,
                backgroundColor: "white",
                position: "relative",
                bgcolor: bgcolor,
                minWidth: minWidth,
                mt: 1
            }}
        >
            <Box
                sx={{
                    bgcolor: bgcolor,
                    // border: "1px solid rgba(0, 0, 0, 0.12)",
                    // borderRadius: 1,
                    position: "absolute",
                    top: -15,
                    left: 30,
                    fontSize: "12px",
                    fontFamily: 'Poppins',
                    fontWeight: fontWeight,
                    px: 2,
                    py: 0.5,
                }}
            >
                {title}
            </Box>
            <Box>{children}</Box>
        </Box>
    );
}

export const Loader = ({ loading }) => {
    return (
        <Backdrop
            open={loading}
            sx={(theme) => ({
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
            })}
        >
            <CircularProgress />
        </Backdrop>
    );
};

export const FormatAmount = (amount) => {
    if (amount === "" || amount === null || amount === undefined) {
        return "";
    }
    const num = Number(amount);
    if (isNaN(num)) {
        return amount;
    }
    return num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
export const formatNumber = (value) => {
    if (!value && value !== 0) return "";
    return new Intl.NumberFormat("en-US").format(value);
};
